import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InvoiceUpdateBody } from '../../features/ng-invoice/ng-invoice.interfaces';

export interface InvoiceOpParams {
  statement_id: number;
  invoice_number: string;
}

@Injectable({
  providedIn: 'root',
})
export class InvoiceOpService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  update(params: InvoiceOpParams, body: InvoiceUpdateBody): Observable<void> {
    return this.http.put<void>(
      `/api/invoiceit/${params.statement_id}/${params.invoice_number}`,
      body
    );
  }

  remove(params: InvoiceOpParams): Observable<void> {
    return this.http.delete<void>(`/api/invoiceit/${params.statement_id}/${params.invoice_number}`);
  }

  release(params: InvoiceOpParams, body: InvoiceUpdateBody): Observable<void> {
    return this.http.post<void>(
      `/api/invoiceit/${params.statement_id}/${params.invoice_number}`,
      body
    );
  }
}
